import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ChevronDown } from "lucide-react";
import { useShop } from "../context/ShopContext";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Medicines", to: "/category/medicines" },
  { label: "Health & Wellness", to: "/category/health-wellness" },
  { label: "Personal Care", to: "/category/personal-care" },
  { label: "Baby Care", to: "/category/baby-care" },
  { label: "Medical Devices", to: "/category/health-devices" },
  { label: "Offers", to: "/offers" },
];

const Navbar = () => {
  const { setModal } = useShop();
  return (
    <nav className="hidden lg:block bg-[#0f9d4b] shadow-sm">
      <div className="max-w-[1400px] mx-auto px-4 flex items-center">
        <Link
          to="/categories"
          className="flex items-center gap-2 bg-[#0b7a3a] hover:bg-[#096831] text-white text-[13.5px] font-semibold px-4 h-11 transition-colors"
        >
          <Menu size={17} />
          All Categories
          <ChevronDown size={15} />
        </Link>
        <div className="flex items-center gap-1 xl:gap-2 ml-4">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-3 h-11 flex items-center text-[13.5px] whitespace-nowrap transition-colors border-b-2 ${
                  isActive
                    ? "text-white font-bold border-white"
                    : "text-white/85 font-medium border-transparent hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <button
            onClick={() => setModal("upload")}
            className="px-3 h-11 flex items-center text-[13.5px] font-medium text-white/85 hover:text-white whitespace-nowrap transition-colors"
          >
            Upload Prescription
          </button>
          <button
            onClick={() => setModal("track")}
            className="px-3 h-11 flex items-center text-[13.5px] font-medium text-white/85 hover:text-white whitespace-nowrap transition-colors"
          >
            Track Order
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
